import { COLORS } from "./color.js";
import { DROPDOWN } from "./dropdown.js";
import { SINGLE_SELECT } from "./singleselect.js";
import { MULTI_SELECT } from "./multiselect.js";
import { FONT } from "./font.js";
import { INPUT } from "./input.js";
import { SPACING } from "./space.js";
import { GLOBAL_FORM } from "./global.form.js";
import { GLOBAL_CHART } from "./global.chart.js";
import { GLOBAL_DATASHEET } from "./global.datasheet.js";
import { USER_SELECT } from "./userselect.js";
import { GLOBAL_TABLE } from "./global.table.js";
import { POPOVER } from "./popover.js";
import { PIVOT } from "./pivot.js";
import { CHART_COLOR } from "./chart.color.js";
import { CALENDAR } from "./calendar.js";
import { DATE } from "./date.js";
import { TIMEPICKER } from "./timepicker.js";
import { BUTTON } from "./button.js";
import { NUMBER } from "./number.js";
import { CURRENCY } from "./currency.js";
import { TEXT_AREA } from "./textarea.js";
import { YES_NO } from "./yesno.js";
import { SLIDER } from "./slider.js";
import { RATING } from "./rating.js";
import { EMAIL } from "./email.js";
import { TEXT } from "./text.js";
import { CHECKBOX } from "./checkbox.js";
import { FONT_FAMILY } from "./fontfamily.js";
import { CHIP } from "./chip.js";
import { AGGREGATION } from "./aggregation.js";
import { SEQUENCE_NUMBER } from "./sequence.number.js";
import { CHECKLIST } from "./checklist.js";
import { RADIO } from "./radio.js";
import { IMAGE } from "./image.js";
import { ATTACHMENT } from "./attachment.js";
import { SHADOW } from "./shadow.js";
import { SMARTATTACHMENT } from "./smartattachment.js";
import { SCANNER } from "./scanner.js";
import { LOOKUP } from "./lookup.js";
import { SIGNATURE } from "./signature.js";
/* App imports */
import { APP_THEME_MODEL } from "./app/index.js";
/* Form imports */
import { FORM_THEME_MODEL } from "./form/index.js";

export const THEME_MODEL = {
  ...COLORS,
  ...FONT,
  ...INPUT,
  ...SPACING,
  ...DROPDOWN,
  ...SINGLE_SELECT,
  ...MULTI_SELECT,
  ...GLOBAL_FORM,
  ...GLOBAL_CHART,
  ...GLOBAL_DATASHEET,
  ...USER_SELECT,
  ...GLOBAL_TABLE,
  ...POPOVER,
  ...PIVOT,
  ...CHART_COLOR,
  ...CALENDAR,
  ...DATE,
  ...SCANNER,
  ...TIMEPICKER,
  ...BUTTON,
  ...NUMBER,
  ...CURRENCY,
  ...TEXT_AREA,
  ...YES_NO,
  ...SLIDER,
  ...RATING,
  ...CHIP,
  ...EMAIL,
  ...TEXT,
  ...CHECKBOX,
  ...FONT_FAMILY,
  ...AGGREGATION,
  ...SEQUENCE_NUMBER,
  ...CHECKLIST,
  ...RADIO,
  ...IMAGE,
  ...ATTACHMENT,
  ...SMARTATTACHMENT,
  ...LOOKUP,
  ...SIGNATURE,
  ...SHADOW,
  ...APP_THEME_MODEL,
  ...FORM_THEME_MODEL
};
